module.exports = __webpack_public_path__ + "img/noi-program-1.39dc7fc0.jpg";